import { _ as _extends } from './extends-a2cb9f0c.esm.js';
import React__default, { useCallback } from 'react';
import SectionedMultiSelect from 'react-native-sectioned-multi-select';
import { A as AppInputLabel } from './index-5ae71f5a.esm.js';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { Platform, View } from 'react-native';
import { u as useTheme } from './useTheme-90e8e2c2.esm.js';
import { useTranslation } from 'react-i18next';

// PROBLEMATIC LIBRARY
const AppMultipleSelectInput = _ref => {
  let {
    items,
    selectedItems,
    onSelectionChange,
    onError = () => {},
    groupByProperty,
    labelOption = "name",
    style,
    placeholder,
    showTextInputLabel,
    label,
    isMandatory,
    inputLabelStyle,
    wrapperContainerStyle,
    hidePlaceholder = true,
    adaptablePlaceholderWidth = false,
    searchable = true,
    inputName = "multiselectOptions",
    isAsync = false,
    promiseOptions,
    maxSelectedValues = 50,
    ...props
  } = _ref;
  useTheme();
  const {
    t
  } = useTranslation();
  const _icons = {
    search: {
      name: "search",
      // search input
      size: 24
    },
    arrowUp: {
      name: "keyboard-arrow-up",
      // dropdown toggle
      size: 22
    },
    arrowDown: {
      name: "keyboard-arrow-down",
      // dropdown toggle
      size: 22
    },
    selectArrowDown: {
      name: "keyboard-arrow-down",
      // select
      size: 24
    },
    close: {
      name: "close",
      // chip close
      size: 16
    },
    check: {
      name: "check",
      // selected item
      size: 16
    },
    cancel: {
      name: "cancel",
      // cancel button
      size: 18
    }
  };
  const itemsAdapter = useCallback(() => {
    const adaptedObject = [];
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (Platform.OS === "web") adaptedObject.push({
        name: item[labelOption],
        id: item.id,
        category: item[groupByProperty]
      });else adaptedObject.push({
        name: item[labelOption],
        id: item.id,
        children: items.filter(i => i[groupByProperty] === item[labelOption])
      });
    }
    return adaptedObject;
  }, [items, groupByProperty]);
  return Platform.OS === "web" ? /*#__PURE__*/React__default.createElement(View, {
    style: wrapperContainerStyle
  }, showTextInputLabel ? /*#__PURE__*/React__default.createElement(AppInputLabel, {
    style: [{
      marginLeft: 20
    }, inputLabelStyle],
    isMandatory: isMandatory,
    label: label
  }) : null, isAsync ? /*#__PURE__*/React__default.createElement(AsyncSelect, _extends({
    placeholder: t(placeholder),
    onChange: onSelectionChange,
    theme: {
      borderRadius: 10
    }
    // defaultValue={selectedItems}
    ,
    value: selectedItems
    // groupBy="category"
    // New props
    ,
    name: inputName,
    loadOptions: promiseOptions,
    closeMenuOnSelect: true,
    hideSelectedOptions: true,
    styles: {
      control: provided => ({
        ...provided,
        borderRadius: 15
      })
    }
  }, props)) : /*#__PURE__*/React__default.createElement(Select, _extends({
    placeholder: t(placeholder),
    onChange: v => {
      if (maxSelectedValues && (v === null || v === void 0 ? void 0 : v.length) <= maxSelectedValues) onSelectionChange(v);else {
        onError(t("error_max_selected_values"));
      }
    },
    theme: {
      borderRadius: 10
    }
    // defaultValue={selectedItems}
    ,
    value: selectedItems
    // groupBy="category"
    // New props
    ,
    name: inputName,
    isSearchable: searchable,
    closeMenuOnSelect: false,
    hideSelectedOptions: true,
    isMulti: true,
    styles: {
      control: provided => ({
        ...provided,
        borderRadius: 15
      })
    }
  }, props))) : /*#__PURE__*/React__default.createElement(SectionedMultiSelect, _extends({
    IconRenderer: FontAwesomeIcon,
    icons: _icons,
    items: itemsAdapter(),
    onSelectedItemsChange: onSelectionChange,
    selectedItems: selectedItems,
    displayKey: labelOption
  }, props));
};
AppMultipleSelectInput.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppMultipleSelectInput",
  "props": {
    "onError": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false
    },
    "labelOption": {
      "defaultValue": {
        "value": "\"name\"",
        "computed": false
      },
      "required": false
    },
    "hidePlaceholder": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    },
    "adaptablePlaceholderWidth": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "searchable": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    },
    "inputName": {
      "defaultValue": {
        "value": "\"multiselectOptions\"",
        "computed": false
      },
      "required": false
    },
    "isAsync": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    },
    "maxSelectedValues": {
      "defaultValue": {
        "value": "50",
        "computed": false
      },
      "required": false
    }
  }
};

export { AppMultipleSelectInput as A };
